export default {
	URL_BASE: "https://distribuidoradcheo.online",

	// URL_BASE: "https://liquidationback.onrender.com/",
	// URL_BASE: "http://localhost:8000",
};
